// extracted by mini-css-extract-plugin
export default {"component":"Ddrx35KnG9br2qKLKNjA","course_list":"KhQCSyc6e5lL2DAnUqKF","courseList":"KhQCSyc6e5lL2DAnUqKF","link":"fs7OPgflakpepaf5rnu6"};